export default __webpack_public_path__ + "static/media/telephone.8bdd5a46.svg";